<template>
    <div>
        <v-container style="max-width:1000px">
            <v-text-field label="Name" v-model="name" />
            <v-checkbox label="Theme" v-model="theme" />
            <div>
                <v-radio-group
                    class="inputField"
                    v-show="theme"
                    v-model="seltheme"
                >
                    <v-row>
                        <v-col>
                            <v-radio
                                label="Standerd"
                                color="primary"
                                value="0"
                            />
                            <v-radio
                                label="Jobbmöte"
                                color="primary"
                                value="1"
                            />
                        </v-col>
                        <v-col>
                            <v-radio
                                label="Svensexa"
                                color="primary"
                                value="2"
                            />
                            <v-radio
                                label="Möhippa"
                                color="primary"
                                value="3"
                            />
                        </v-col>
                        <v-col>
                            <v-radio label="Middag" color="primary" value="4" />
                            <v-radio label="Resa" color="primary" value="5" />
                        </v-col>
                        <v-col>
                            <v-radio label="Möte" color="primary" value="6" />
                            <v-radio label="Fest" color="primary" value="7" />
                        </v-col>
                        <v-col>
                            <v-radio
                                label="Födelsedag"
                                color="primary"
                                value="8"
                            />
                            <v-radio label="Kalas" color="primary" value="9" />
                            <v-radio
                                label="Studentskiva"
                                color="primary"
                                value="10"
                            />
                        </v-col>
                    </v-row>
                </v-radio-group>
            </div>
            <v-textarea label="Ads code" v-model="adcode" />
            <v-btn color="success" @click="submit">Submit </v-btn>
        </v-container>
    </div>
</template>

<script>
import store from "../../../../store";
import axios from "axios";
export default {
    data: function() {
        return {
            theme: false,
            name: "",
            adcode: "",
            seltheme: "",
            themes: [
                "Möte",
                "Övrigt",
                "Jobbmöte",
                "Svensexa",
                "Möhippa",
                "Middag",
                "Resa",
                "Fest",
                "Födelsedag",
                "Kalas",
                "Studentskiva",
                "date"
            ],
            store: store
        };
    },
    created: function() {
        if (this.store.state.user.role == "user")
            this.$router.replace("/dashboard");
        if (!this.store.state.isLoggedIn) this.$router.replace("/login");
    },
    methods: {
        submit: async function() {
            let Formdata = new FormData();
            if (this.theme) Formdata.set("theme", this.seltheme);
            else Formdata.set("theme", 11);

            Formdata.set("name", this.name);
            Formdata.set("adcode", this.adcode);
            Formdata.set("istheme", this.theme);

            var config = {
                url: `${this.store.state.baseURL}newad`,
                method: "post",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: Formdata
            };

            try {
                await axios(config);
            } catch (err) {
                console.log(err);
            }
            this.$router.replace("/dashboard");
        }
    }
};
</script>

<style></style>
